<template>
  <div id="centerDiv" class="mapcontainer">
    <Map :url="configUrl" @onload="onMapload" :options="options" />
  </div>
</template>

<script>
import Map from "./map.vue";

export default {
  name: "glgview",
  components: {
    Map,
  },

  data() {
    return {
      configUrl: "/config/config.json",
      options: {
        scene: {
            center: { lat: 31.868646, lng: 117.249678, alt: 1485, heading: 110, pitch: -40 },
          },
          layers: [
            {
              type: "geojson",
              name: "道路线",
              url: "//data.mars3d.cn/file/geojson/hefei-road.json",
              symbol: {
                styleOptions: {
                  materialType: "PolylineGlow",
                  glowPower: 0.2,
                  color: "#FF4500",
                  width: 12,
                  opacity: 0.8,
                  // clampToGround: true,
                },
              },
              popup: "{name}",
              zIndex: 20,
              show: true,
            },
            {
              type: "geojson",
              name: "河流(面状)",
              url: "//data.mars3d.cn/file/geojson/hefei-water.json",
              symbol: {
                type: "water",
                styleOptions: {
                  normalMap: "img/textures/waterNormals.jpg", // 水正常扰动的法线图
                  frequency: 5000.0, // 控制波数的数字。
                  animationSpeed: 0.05, // 控制水的动画速度的数字。
                  amplitude: 9.0, // 控制水波振幅的数字。
                  specularIntensity: 0.8, // 控制镜面反射强度的数字。
                  baseWaterColor: "#00baff", // rgba颜色对象基础颜色的水。#00ffff,#00baff,#006ab4
                  blendColor: "#00baff", // 从水中混合到非水域时使用的rgba颜色对象。
                  // clampToGround: true,
                },
              },
              popup: "{name}",
              zIndex: 10,
              show: true,
            },
          ],
      },
    };
  },
  mounted() {},
  watch: {},

  methods: {
    onMapload(map) {
      this.map = map;
          map.scene.light = new this.Cesium.DirectionalLight({
          direction: map.scene.camera.direction,
        });
        map.on(this.mars3d.EventType.cameraMoveEnd, function (event) {
          map.scene.light.direction = map.scene.camera.direction;
        });

        var bloomEffect = new this.mars3d.effect.BloomEffect({
          enabled: true,
        });
      map.addEffect(bloomEffect);

      const fragmentShader2 = `
          // 注意shader中写浮点数是，一定要带小数点，否则会报错，比如0需要写成0.0，1要写成1.0
          float _baseHeight = 0.0; // 物体的基础高度，需要修改成一个合适的建筑基础高度
          float _heightRange = 80.0; // 高亮的范围(_baseHeight ~ _baseHeight + _heightRange)
          float _glowRange = 100.0; // 光环的移动范围(高度)

          // 建筑基础色
          float mars_height = marsJzwHeight - _baseHeight;
          float mars_a11 = fract(czm_frameNumber / 120.0) * 3.14159265 * 2.0;
          float mars_a12 = mars_height / _heightRange + sin(mars_a11) * 0.1;
          gl_FragColor *= vec4(vec3(mars_a12), 1.0);// 渐变

          // 动态光环
          float time = fract(czm_frameNumber / 360.0);
          time = abs(time - 0.5) * 2.0;
          float mars_h = clamp(mars_height / _glowRange, 0.0, 1.0);
          float mars_diff = step(0.005, abs(mars_h - time));
          gl_FragColor.rgb += gl_FragColor.rgb * (1.0 - mars_diff);
       `;

        



     //模型
       const tiles4dLayer = new this.mars3d.layer.TilesetLayer({
          type: "3dtiles",
          name: "充电站",
          url: "//data.mars3d.cn/3dtiles/jzw-hefei/tileset.json",
          maximumScreenSpaceError: 1,
         maximumMemoryUsage: 1024,
          marsJzwStyle:fragmentShader2,
          popup: [
            { field: "objectid", name: "站点编号" },
            { field: "name", name: "站点名称" },
            { field: "height", name: "设备数量", unit: "台" },
          ],
           style: {
            color: {
              conditions: [["true", "rgba(16, 119, 209, 1)"]],
            },
          },
        });
        map.addLayer(tiles4dLayer);
              

            // 自定义特效 Shader
 
        //不改动cesium源码版本的建筑物样式
      //  tiles4dLayer.setCustomShader(fragmentShader);
    },
  },
  updated() {},
};
</script>

<style>
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.boxDiv {
  position: absolute;
  top: 30px;
  left: 40px;
  z-index: 999;
}
</style>
